import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import LoginBgImg from '@/assets/loginBg.png';
import LoginLogoImg from '@/assets/loginLogo.png';

const SharedBasketMessageCard = ({
  icon,
  title,
  body,
  children,
  hint,
}: {
  icon: ReactNode;
  title: ReactNode;
  body: ReactNode;
  children?: ReactNode;
  hint?: ReactNode;
}) => (
  <Root>
    <Card>
      <CardHeader>
        <Logo src={LoginLogoImg} alt="Partner Portal Logo" />
      </CardHeader>
      <CardBody>
        <Icon aria-hidden>{icon}</Icon>
        <Title>{title}</Title>
        <Body>{body}</Body>
        {children}
        {hint && <Hint>{hint}</Hint>}
      </CardBody>
    </Card>
  </Root>
);

const Root = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: `url(${LoginBgImg}) no-repeat center center`,
  backgroundSize: 'cover',
});

const Card = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '540px',
  maxWidth: '90%',
  left: '50%',
  color: theme.palette.textPrimaryWhite,
  transform: 'translateX(-50%)',
  top: '20%',
  borderRadius: 8,
  overflow: 'hidden',
  boxShadow: '0px 4px 10px 0px #00000066',
}));

const CardHeader = styled('div')({
  background: '#E6162680',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '12px 0',
});

const Logo = styled('img')({
  width: 90,
});

const CardBody = styled('div')(({ theme }) => ({
  background: theme.palette.white,
  padding: '42px 60px',
  display: 'flex',
  textAlign: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  color: theme.palette.textPrimaryBlack,
}));

const Icon = styled('div')({
  fontSize: 34,
  lineHeight: '38px',
});

const Title = styled('div')(({ theme }) => ({
  fontSize: 24,
  lineHeight: '28px',
  fontWeight: 600,
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
}));

const Body = styled('div')(({ theme }) => ({
  fontSize: 14,
  lineHeight: '20px',
  marginBottom: theme.spacing(3),
  color: theme.palette.grey600,
}));

const Hint = styled('div')(({ theme }) => ({
  fontSize: 13,
  lineHeight: '18px',
  marginTop: theme.spacing(2),
  color: theme.palette.grey500,
}));

export default SharedBasketMessageCard;
